import { render, staticRenderFns } from "./HolidayDetail.vue?vue&type=template&id=32b024cd&scoped=true&"
import script from "./HolidayDetail.vue?vue&type=script&lang=js&"
export * from "./HolidayDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b024cd",
  null
  
)

export default component.exports